"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optimisticEndMockTest = exports.updateCacheOnEndMockTest = exports.END_MOCK_TEST = exports.optimisticToggleFlaggedQuestion = exports.updateCacheToggleFlaggedQuestion = exports.TOGGLE_FLAGGED_MARK = exports.BUILD_MOCK_TEST_MARKSHEET = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
exports.BUILD_MOCK_TEST_MARKSHEET = (0, client_1.gql) `
  mutation BuildMockTestMarksheet($mockTestId: Int!, $duration: Int!) {
    restricted {
      buildMockTestMarksheet(mockTestId: $mockTestId, duration: $duration) {
        id
      }
    }
  }
`;
exports.TOGGLE_FLAGGED_MARK = (0, client_1.gql) `
  mutation ToggleFlaggedMark(
    $marksheetId: Int!
    $markId: Int!
    $isFlagged: Boolean!
  ) {
    restricted {
      toggleFlaggedMark(
        marksheetId: $marksheetId
        markId: $markId
        isFlagged: $isFlagged
      ) {
        id
        flagged
      }
    }
  }
`;
const updateCacheToggleFlaggedQuestion = (cache, result) => {
    const { toggleFlaggedMark } = result?.data?.restricted || {};
    if (!toggleFlaggedMark) {
        return;
    }
    const { id, flagged } = toggleFlaggedMark;
    cache.writeFragment({
        id: cache.identify({ id, __typename: 'MarksheetMark' }),
        data: {
            flagged,
        },
        fragment: fragments_1.MARK_FLAGGED_QUESTION,
    });
};
exports.updateCacheToggleFlaggedQuestion = updateCacheToggleFlaggedQuestion;
const optimisticToggleFlaggedQuestion = (mark, flagged) => ({
    restricted: {
        __typename: 'RestrictedMutation',
        toggleFlaggedMark: {
            ...mark,
            flagged,
        },
    },
});
exports.optimisticToggleFlaggedQuestion = optimisticToggleFlaggedQuestion;
exports.END_MOCK_TEST = (0, client_1.gql) `
  mutation EndMockTest($marksheetId: Int!) {
    restricted {
      endMockTest(marksheetId: $marksheetId) {
        id
        timeTaken
        startedAt
        endedAt
        mockTestId
        completed
        correct
        incorrect
        totalQuestions
        duration
      }
    }
  }
`;
const updateCacheOnEndMockTest = (cache, result, options) => {
    const { endMockTest } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !endMockTest) {
        return;
    }
    const { marksheetId: id } = variables;
    cache.writeFragment({
        id: cache.identify({ id, __typename: 'Marksheet' }),
        data: {
            completed: true,
            timeTaken: endMockTest.timeTaken,
            correct: endMockTest.correct,
            incorrect: endMockTest.incorrect,
            duration: endMockTest.duration,
            endedAt: endMockTest.endedAt,
        },
        fragment: fragments_1.COMPLETED_MOCK_TEST_MARKSHEET_FRAGMENT,
    });
    cache.writeFragment({
        id: cache.identify({ id: endMockTest.mockTestId, __typename: 'MockTest' }),
        data: {
            lastMarksheetId: endMockTest.id,
            lastMarksheetStartedAt: endMockTest.startedAt,
            lastMarksheetEndedAt: endMockTest.endedAt,
            correct: endMockTest.correct,
            incorrect: endMockTest.incorrect,
        },
        fragment: fragments_1.COMPLETED_MOCK_TESTS_FRAGMENT,
    });
};
exports.updateCacheOnEndMockTest = updateCacheOnEndMockTest;
const optimisticEndMockTest = (marksheet) => ({
    restricted: {
        __typename: 'RestrictedMutation',
        endMockTest: {
            __typename: 'Marksheet',
            ...marksheet,
            completed: true,
        },
    },
});
exports.optimisticEndMockTest = optimisticEndMockTest;
